/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: false, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "Pulkit's Portfolio",
  description:
    "Enthusiastic Professional Software Developer dedicated to create impact by craft cutting-edge solutions with top-notch quality.",
  og: {
    title: "Pulkit Munjral Portfolio",
    type: "website",
    url: "https://pulkitmunjral.github.io/",
  },
};

//Home Page
const greeting = {
  title: "Pulkit Munjral",
  logo_name: "Pulkit Munjral",
  nickname: "",
  subTitle:
  "Enthusiastic Professional Software Developer dedicated to create impact by craft cutting-edge solutions with top-notch quality.",
  resumeLink:
    "https://drive.google.com/file/d/1ECMb8HONV0ndtd1zbjVA1iM-dIU-2lbF/view?usp=drivesdk",
  portfolio_repository: "https://github.com/pulkitmunjral/pulkitmunjral.github.io",
  githubProfile: "https://github.com/pulkitmunjral",
};

const socialMediaLinks = [
  {
    name: "Github",
    link: "https://github.com/pulkitmunjral",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/pulkitmunjral/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  {
    name: "Gmail",
    link: "mailto:pulkit.munjral@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
  {
    name: "Instagram",
    link: "https://www.instagram.com/pulkit.munjral/",
    fontAwesomeIcon: "fa-instagram", // Reference https://fontawesome.com/icons/instagram?style=brands
    backgroundColor: "#E4405F", // Reference https://simpleicons.org/?q=instagram
  },
  {
    name: "Medium",
    link: "https://medium.com/@pulkitmunjral",
    fontAwesomeIcon: "fa-medium", // Reference https://fontawesome.com/icons/medium?f=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=instagram
  },
];

const skills = {
  data: [
    {
      title: "Backend Development",
      fileName: "DataScienceImg",
      skills: [
        "⚡ Developing highly scalable production ready backend apis using Django.",
        "⚡ Design efficient schemas to optimize database performance.",
        "⚡ Optimize code for scalability, utilizing redis for caching api requests.",
      ],
      softwareSkills: [
        {
          skillName: "Python",
          fontAwesomeClassname: "ion-logo-python",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB",
          },
        },
        {
          skillName: "Django",
          fontAwesomeClassname: "simple-icons:django",
          style: {
            color: "#47A248",
          },
        },
        {
          skillName: "Flask",
          fontAwesomeClassname: "simple-icons:flask",
          style: {
            color: "#99999",
          },
        },
        {
          skillName: "Oracle",
          fontAwesomeClassname: "simple-icons:oracle",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#47A248",
          },
        },
        {
          skillName: "Redis",
          fontAwesomeClassname: "simple-icons:redis",
          style: {
            backgroundColor: "transparent",
            color: "#E34F26",
          },
        },
        {
          skillName: "Jenkins",
          fontAwesomeClassname: "simple-icons:jenkins",
          style: {
            color: "#99999"
          },
        },
      ],
    },
    {
      title: "Frontend Development",
      fileName: "FullStackImg",
      skills: [
        "⚡ Building responsive website front end using React.js",
        "⚡ Handle asynchronous operations for smooth data retrieval and updates.",
        "⚡ Ensure cross-browser compatibility for a consistent user experience",
      ],
      softwareSkills: [
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#000000",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
      ],
    },
    {
      title: "Test Automation",
      fileName: "ProjectsImg",
      skills: [
        "⚡ Devloped behavior-driven automation framework using Gherkin syntax.",
        "⚡ Implement step definitions in Python for each Gherkin scenario step.",
        "⚡ Integrate Behave tests into CI/CD pipelines for automated testing",
      ],
      softwareSkills: [
        {
          skillName: "Python",
          fontAwesomeClassname: "ion-logo-python",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB",
          },
        },
        {
          skillName: "Oracle",
          fontAwesomeClassname: "simple-icons:oracle",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "PostgreSQL",
          fontAwesomeClassname: "simple-icons:postgresql",
          style: {
            color: "#336791",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#47A248",
          },
        },
        {
          skillName: "BitBucket",
          fontAwesomeClassname: "simple-icons:bitbucket",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB",
          },
        },
        {
          skillName: "Jenkins",
          fontAwesomeClassname: "simple-icons:jenkins",
          style: {
            color: "#99999"
          },
        },
        {
          skillName: "Jira",
          fontAwesomeClassname: "simple-icons:jira",
          style: {
            color: "#3776AB",
          },
        },
      ],
    },
    // {
    //   title: "UI/UX Design",
    //   fileName: "DesignImg",
    //   skills: [
    //     "⚡ Designing highly attractive user interface for mobile and web applications",
    //     "⚡ Customizing logo designs and building logos from scratch",
    //     "⚡ Creating the flow of application functionalities to optimize user experience",
    //   ],
    //   softwareSkills: [
    //     {
    //       skillName: "Adobe XD",
    //       fontAwesomeClassname: "simple-icons:adobexd",
    //       style: {
    //         color: "#FF2BC2",
    //       },
    //     },
    //     {
    //       skillName: "Figma",
    //       fontAwesomeClassname: "simple-icons:figma",
    //       style: {
    //         color: "#F24E1E",
    //       },
    //     },
    //     {
    //       skillName: "Adobe Illustrator",
    //       fontAwesomeClassname: "simple-icons:adobeillustrator",
    //       style: {
    //         color: "#FF7C00",
    //       },
    //     },
    //     {
    //       skillName: "Inkscape",
    //       fontAwesomeClassname: "simple-icons:inkscape",
    //       style: {
    //         color: "#000000",
    //       },
    //     },
    //   ],
    // },
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [
    {
      siteName: "LeetCode",
      iconifyClassname: "simple-icons:leetcode",
      style: {
        color: "#F79F1B",
      },
      profileLink: "https://leetcode.com/pulkitmunjral/",
    },
    {
      siteName: "HackerRank",
      iconifyClassname: "simple-icons:hackerrank",
      style: {
        color: "#2EC866",
      },
      profileLink: "https://www.hackerrank.com/profile/pulkit_munjral",
    },
    {
      siteName: "Codechef",
      iconifyClassname: "simple-icons:codechef",
      style: {
        color: "#5B4638",
      },
      profileLink: "https://www.codechef.com/users/pulkitmunjral",
    },
    // {
    //   siteName: "Codeforces",
    //   iconifyClassname: "simple-icons:codeforces",
    //   style: {
    //     color: "#1F8ACB",
    //   },
    //   profileLink: "http://codeforces.com/profile/layman_brother",
    // },
    {
      siteName: "Hackerearth",
      iconifyClassname: "simple-icons:hackerearth",
      style: {
        color: "#323754",
      },
      profileLink: "https://www.hackerearth.com/@pulkit.munjral",
    },
    // {
    //   siteName: "Kaggle",
    //   iconifyClassname: "simple-icons:kaggle",
    //   style: {
    //     color: "#20BEFF",
    //   },
    //   profileLink: "https://www.kaggle.com/laymanbrother",
    // },
  ],
};

const degrees = {
  degrees: [
    {
      title: "B.Tech in Electronics and Communication",
      subtitle: "Jaipur Engineering College and Research Centre",
      logo_path: "jecrc_logo3.png",
      alt_name: "JECRC Foundation",
      duration: "2016 - 2020",
      descriptions: [
        "⚡ I have studied basic software engineering subjects like DS, Algorithms, DBMS, OS, CA, AI etc.",
        "⚡ Apart from this, I have done courses on Mahine Learning, Data Science and IOT",
        "⚡ I organised a Tech-fest Renaissance 2K19 and was award for making it the best.",
      ],
      website_link: "https://jecrcfoundation.com/",
    },
    {
      title: "Good Shephered Public School",
      subtitle: "12th Standard",
      logo_path: "gsps2.png",
      alt_name: "GSPS",
      duration: "2015 - 2016",
      descriptions: [
        "⚡ I studied Physics, Chemistery and Maths.",
        "⚡ Apart from this, I started learning how machine works and how machines have changed our life.",
      ],
      website_link: "https://www.goodshepherdpublicschool.in/",
    },
    {
      title: "Good Shephered Public School",
      subtitle: "10th Standard",
      logo_path: "gsps2.png",
      alt_name: "GSPS",
      duration: "2013 - 2014",
      descriptions: [
        "⚡ I studied basic CBSE curriculum.",
        "⚡ I scored perfect 10 CGPA in my favorite subject Maths.",
      ],
      website_link: "https://www.goodshepherdpublicschool.in/",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "Machine Leaning",
      subtitle: "by Saurabh",
      logo_path: "techi_logo.png",
      certificate_link: "",
      alt_name: "TechieNest",
      color_code: "#D83B0199",
    },
    {
      title: "Python",
      subtitle: "by Hacker Rank",
      logo_path: "HackerRank_logo.png",
      certificate_link:
        "https://www.hackerrank.com/certificates/3fa75b4d6ab9",
      alt_name: "Hacker Rank",
      color_code: "#0C9D5899",
    },
    {
      title: "SQL Bootcamp",
      subtitle: "by Jose Portila",
      logo_path: "udemy_logo.png",
      certificate_link:
        "https://www.udemy.com/certificate/UC-79820a22-419a-43a2-9ad7-8156d13fed97/",
      alt_name: "Udemy",
      color_code: "#2A73CC",
    },
    {
      title: "Git and Github",
      subtitle: "by Colt Steele",
      logo_path: "udemy_logo.png",
      certificate_link:
        "https://www.udemy.com/certificate/UC-b7e33fb3-ddb1-4fd1-ab80-9e10bcc60233/",
      alt_name: "Udemy",
      color_code: "#2A73CC",
    },
    {
      title: "Probelum Solving",
      subtitle: "by Hacker Rank",
      logo_path: "HackerRank_logo2.png",
      certificate_link:
        "https://www.hackerrank.com/certificates/5f17073eb44f",
      alt_name: "Hacker Rank",
      color_code: "#000000",
    },
    {
      title: "Microservices Architecture",
      subtitle: "by Memi Lavi",
      logo_path: "udemy_logo2.png",
      certificate_link:
        "https://www.udemy.com/certificate/UC-cdc36984-0098-4570-b64c-06b0d8e222c4/",
      alt_name: "Udemy",
      color_code: "#00000099",
    },
    {
      title: "Java Basic",
      subtitle: "by Hacker Rank",
      logo_path: "HackerRank_logo.png",
      certificate_link:
        "https://www.hackerrank.com/certificates/63d3c1c21b91",
      alt_name: "Hacker Rank",
      color_code: "#0C9D5899",
    },
    {
      title: "Jira",
      subtitle: "by Masha Ostroumova",
      logo_path: "udemy_logo2.png",
      certificate_link:
        "https://www.udemy.com/certificate/UC-e2487198-2c6b-4f2a-9e36-d76d9ea38558/",
      alt_name: "Udemy",
      color_code: "#00000099",
    },
    {
      title: "IOT",
      subtitle: "by Saurabh",
      logo_path: "techi_logo.png",
      certificate_link: "",
      alt_name: "TechieNest",
      color_code: "#D83B0199",
    },
    
    {
      title: "Python Bootcamp",
      subtitle: "by Jose Portila",
      logo_path: "udemy_logo.png",
      certificate_link:
        "https://www.udemy.com/certificate/UC-6ec3bc2a-2a80-4fe4-83ae-daa3cb8dd0ac/",
      alt_name: "Udemy",
      color_code: "#2A73CC",
    },
    {
      title: "SQL",
      subtitle: "by Hacker Rank",
      logo_path: "HackerRank_logo2.png",
      certificate_link:
        "https://www.hackerrank.com/certificates/75a89245e882",
      alt_name: "Hacker Rank",
      color_code: "#000000",
    },
    
    // {
    //   title: "ML on GCP",
    //   subtitle: "- GCP Training",
    //   logo_path: "google_logo.png",
    //   certificate_link:
    //     "https://www.coursera.org/account/accomplishments/specialization/EB4VJARK8647",
    //   alt_name: "Google",
    //   color_code: "#0C9D5899",
    // },
    // {
    //   title: "Data Science",
    //   subtitle: "- Alex Aklson",
    //   logo_path: "ibm_logo.png",
    //   certificate_link:
    //     "https://www.coursera.org/account/accomplishments/specialization/PLEAPCSJBZT5",
    //   alt_name: "IBM",
    //   color_code: "#1F70C199",
    // },
    // {
    //   title: "Big Data",
    //   subtitle: "- Kim Akers",
    //   logo_path: "microsoft_logo.png",
    //   certificate_link:
    //     "https://drive.google.com/file/d/164zKCFOsI4vGqokc-Qj-e_D00kLDHIrG/view",
    //   alt_name: "Microsoft",
    //   color_code: "#D83B0199",
    // },
    // {
    //   title: "Advanced Data Science",
    //   subtitle: "- Romeo Kienzler",
    //   logo_path: "ibm_logo.png",
    //   certificate_link:
    //     "https://www.coursera.org/account/accomplishments/verify/BH2T9BRU87BH",
    //   alt_name: "IBM",
    //   color_code: "#1F70C199",
    // },
    // {
    //   title: "Advanced ML on GCP",
    //   subtitle: "- GCP Training",
    //   logo_path: "google_logo.png",
    //   certificate_link:
    //     "https://www.coursera.org/account/accomplishments/verify/5JZZM7TNQ2AV",
    //   alt_name: "Google",
    //   color_code: "#0C9D5899",
    // },
    // {
    //   title: "DL on Tensorflow",
    //   subtitle: "- Laurence Moroney",
    //   logo_path: "deeplearning_ai_logo.png",
    //   certificate_link:
    //     "https://www.coursera.org/account/accomplishments/verify/6T4DCUGNK8J8",
    //   alt_name: "deeplearning.ai",
    //   color_code: "#00000099",
    // },
    // {
    //   title: "Fullstack Development",
    //   subtitle: "- Jogesh Muppala",
    //   logo_path: "coursera_logo.png",
    //   certificate_link:
    //     "https://www.coursera.org/account/accomplishments/certificate/NRANJA66Y2YA",
    //   alt_name: "Coursera",
    //   color_code: "#2A73CC",
    // },
    // {
    //   title: "Kuberenetes on GCP",
    //   subtitle: "- Qwiklabs",
    //   logo_path: "gcp_logo.png",
    //   certificate_link:
    //     "https://google.qwiklabs.com/public_profiles/e4d5a92b-faf6-4679-a70b-a9047c0cd750",
    //   alt_name: "GCP",
    //   color_code: "#4285F499",
    // },
    // {
    //   title: "Cryptography",
    //   subtitle: "- Saurabh Mukhopadhyay",
    //   logo_path: "nptel_logo.png",
    //   certificate_link:
    //     "https://drive.google.com/open?id=1z5ExD_QJVdU0slLkp8CBqSF3-C3g-ro_",
    //   alt_name: "NPTEL",
    //   color_code: "#FFBB0099",
    // },
    // {
    //   title: "Cloud Architecture",
    //   subtitle: "- Qwiklabs",
    //   logo_path: "gcp_logo.png",
    //   certificate_link:
    //     "https://google.qwiklabs.com/public_profiles/5fab4b2d-be6f-408c-8dcb-6d3b58ecb4a2",
    //   alt_name: "GCP",
    //   color_code: "#4285F499",
    // },
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "I have worked with some leading MNCs as Backend Developer and also passionate about how things actually work that allow me to explore and innovate further.",
  description:
    "",
  header_image_path: "experience.svg",
  degrees: [
    {
      title: "Software Development Engineer",
      subtitle: "Airtel Digital, Pune, Maharashtra",
      logo_path: "airtel_logo.png",
      alt_name: "Airtel",
      duration: "August/2022 - Present",
      descriptions: [
        "⚡ Created independent Rest APIs using Django-Python, resulting in a significant reduction of data collection efforts by approximately 90%.",
        "⚡ Enhanced user engagement by developing a highly responsive and user-friendly front-end, leveraging React.js to reduce loading time by 20%.",
        "⚡ Engineered a revolutionary test data bot, resulting in a remarkable decrease in turnaround time and saving 100 man-days of effort monthly.",
        "⚡ Boosted project efficiency by 30% through streamlined integration with Jira/Confluence.",
        "⚡ Optimized data storage with SQL/MongoDB and accelerated development using Jenkins.",
        "⚡ Awarded with Airtel Einstein Award for creating a revolutionary test data bot."
      ],
      website_link: "https://www.airtel.in/",
    },
    {
      title: "Software Engineer",
      subtitle: "Accenture, Gurgaon, Haryana",
      logo_path: "accenture_log2.png",
      alt_name: "Accenture",
      duration: "June/2022 - August/2022",
      descriptions: [
        "⚡ Deployed an ElasticSearch stack, empowering the generation and access of accurate real-time execution reports with enhanced interactivity.",
        "⚡ Awarded with Accenture Appreciation Awarded for independently managing a critical project with exceptional efficiency.",
      ],
      website_link: "https://www.accenture.com/",
    },
    {
      title: "Associate Software Engineer",
      subtitle: "Accenture, Gurgaon, Haryana",
      logo_path: "accenture_log3.png",
      alt_name: "Accenture",
      duration: "January/2021 - June/2022",
      descriptions: [
        "⚡ Engineered a highly efficient Behave Framework using Selenium-Python, leading to a significant 80% reduction in manual intervention requirements.",
        "⚡ Streamlined the process by integrating Jenkins with a Telegram Bot, facilitating the seamless delivery of comprehensive test results and reports via Telegram.",
      ],
      website_link: "https://www.accenture.com/",
    },
    {
      title: "Software Development Intern",
      subtitle: "TechieNest, Jaipur, Rajasthan",
      logo_path: "techi_logo.png",
      alt_name: "TechieNest",
      duration: "May/2019 - June/2019",
      descriptions: [
        "⚡ Worked on various Machine learning projects.",
        "⚡ Designed Various algorithms for different objects detection using Deep Learning.",
        "⚡ Made a prototype of personal assistant (JARVIS), capable of recognizing user face with the help of pre prepared deep learning models.",
      ],
      website_link: "https://www.airtel.in/",
    },
  ],
  sections: [
    {
      title: "Work",
      work: true,
      experiences: [
        {
          title: "Associate AI Engineer",
          company: "Legato Health Technology",
          company_url: "https://legatohealthtech.com/",
          logo_path: "legato_logo.png",
          duration: "June 2020 - Aug 2021",
          location: "Hyderabad, Telangana",
          description:
            "I am working on automating healthcare products. The projects involve automation for process improvements and for significantly enhancing the profits. I am currently working on Cancer Survival and Reoccurence Prediction. Our goal is to make AI system which scales and removes doctor dependency as much as possible.",
          color: "#0879bf",
        },
        {
          title: "Android and ML Developer",
          company: "Muffito Incorporation",
          company_url: "https://www.linkedin.com/company/muffito-inc/about/",
          logo_path: "muffito_logo.png",
          duration: "May 2018 - Oct 2018",
          location: "Pune, Maharashtra",
          description:
            "I have created complete Android Application for locating Pub, Bar and beverage shops around you. I have also worked on implementation of algorithms for Face Detection, Text extraction from Image. I was involved in a team for creating complete software architecure of mobile and web application as well as admin panel for company.",
          color: "#9b1578",
        },
        {
          title: "Android Developer",
          company: "FreeCopy Pvt. Ltd.",
          company_url: "https://www.linkedin.com/company/freecopy/about/",
          logo_path: "freecopy_logo.png",
          duration: "Nov 2017 - Dec 2017",
          location: "Ahmedabad, Gujarat",
          description:
            "FreeCopy is the Start up from Indian Institute of Management, Ahmedabad. I have changed the integration of the whole app from Google to Firebase. I learnt the efﬁcient ways of Data communications like Retroﬁt, Eventbus etc. I experienced the real time start up. I learnt the Design thinking of UI on perspective of People.",
          color: "#fc1f20",
        },
      ],
    },
    {
      title: "Internships",
      experiences: [
        {
          title: "Machine Learning Intern",
          company: "TikTok Inc.",
          company_url: "https://www.tiktok.com/en/",
          logo_path: "tiktok_logo.png",
          duration: "May 2022 - Aug 2022",
          location: "San Francisco, USA",
          description:
            "Building new features on the backend recommendation system, specifically ranking algorithms for Ads that touch hundreds of millions of people around the world. Improving online and offline content ranking algorithms by performing hard sample data replays for training steps.",
          color: "#000000",
        },
        {
          title: "Data Science Research Intern",
          company: "Delhivery Pvt. Ltd.",
          company_url: "https://www.delhivery.com/",
          logo_path: "delhivery_logo.png",
          duration: "May 2019 - Sept 2019",
          location: "Gurgaon, Haryana",
          description:
            "I have worked on project of predicting freight rates based on previous data. There were two objectives: (1) To build a forecasting engine to predict daily freight rates. (2) To embed feature in the model which can explain the seasonal major changes in freight rate based on regions and locations. I have closely worked with deep learning models in combination with statistical methods to create solution for this. At the end of internship, I had created model deployed on AWS EC2 with the use of Kafka stream jobs, ElasticSearch and PostgreSQL.",
          color: "#ee3c26",
        },
        {
          title: "Data Science Intern",
          company: "Intel Indexer LLC",
          company_url:
            "https://opencorporates.com/companies/us_dc/EXTUID_4170286",
          logo_path: "intel_logo.jpg",
          duration: "Nov 2018 - Dec 2018",
          location: "Work From Home",
          description:
            "This is financial Solution Company. I have made Supervised Learning model for the company which can perform time series analysis on Stock price data for 32 companies. I have built LSTM Neural Networks Model and trained the data of 32 companies for last 2 years. This model is also used for forecasting.",
          color: "#0071C5",
        },
      ],
    },
    {
      title: "Volunteerships",
      experiences: [
        {
          title: "Google Explore ML Facilitator",
          company: "Google",
          company_url: "https://about.google/",
          logo_path: "google_logo.png",
          duration: "June 2019 - April 2020",
          location: "Hyderabad, Telangana",
          description:
            "Explore Machine Learning (ML) is a Google-sponsored program for university students to get started with Machine Learning. The curriculum offers 3 tracks of ML Content (Beginner, Intermediate, Advanced) and relies on university student facilitators to train other students on campus and to build opensource projects under this program.",
          color: "#4285F4",
        },
        {
          title: "Microsoft Student Partner",
          company: "Microsoft",
          company_url: "https://www.microsoft.com/",
          logo_path: "microsoft_logo.png",
          duration: "Aug 2019 - May 2020",
          location: "Hyderabad, Telangana",
          description:
            "Microsoft Student Partner is a program for university students to lead the awareness and use of Cloud especially Azure tools in the development of their projects and startups. Under this program, I have organised hands on workshops and seminars to teach Cloud Computing concepts to students.",
          color: "#D83B01",
        },
        {
          title: "Mozilla Campus Captain",
          company: "Mozilla",
          company_url: "https://www.mozilla.org/",
          logo_path: "mozilla_logo.png",
          duration: "Oct 2019 - May 2020",
          location: "Kurnool, Andhra Pradesh",
          description:
            "My responsibility for this program was to create opensource environment in college and in the city. We have organised multiple hackathons on the problems collected by ordinary people from Kurnool city. We have build opensource community of our own college. The community is available at dsc_iiitdmk on github.",
          color: "#000000",
        },
        {
          title: "Developer Students Club Member",
          company: "DSC IIITDM Kurnool",
          company_url:
            "https://www.linkedin.com/company/developer-students-club-iiitdm-kurnool",
          logo_path: "dsc_logo.png",
          duration: "Jan 2018 - May 2020",
          location: "Kurnool, Andhra Pradesh",
          description:
            "We have well established developer club in college which is directly associated with Google Developers. We have developed many interdisciplinary projects under the membership of this club. We have organised workshops and activities on Android Application Development, Flutter and React JS.",
          color: "#0C9D58",
        },
        {
          title: "Developer Program Member",
          company: "Github",
          company_url: "https://github.com/",
          logo_path: "github_logo.png",
          duration: "July 2019 - PRESENT",
          location: "Work From Home",
          description:
            "I am actively contributing to many opensource projects. I have contributed to projects of organisations like Tensorflow, Uber, Facebook, Google, Scikit-learn, Kiwix, Sympy, Python, NVLabs, Fossasia, Netrack, Keras etc. These contributions include bug fixes, feature requests and formulating proper documentation for project.",
          color: "#181717",
        },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My most projects makes use of vast variety of latest technologies and tools. My best experience is to create IOT projects and to see them adding some practical value in life.",
  avatar_image_path: "projects_image.svg",
};

const publicationsHeader = {
  title: "Publications",
  description:
    "I have worked on and published a few research papers and published under Airtel Digital.",
  avatar_image_path: "projects_image.svg",
};

const publications = {
  data: [
    {
      id: "1",
      name: "Ocean of Data — Real Time Solution to Test Data Challenges",
      createdAt: "2023-01-09T16:26:54Z",
      description: "Developed Ocean of data a test data bot to solve test data needs.",
      url:
        "https://medium.com/airteldigital/ocean-of-data-real-time-solution-to-test-data-challenges-c31e9f3d7d30",
    },
    {
      id: "2",
      name: "Unleashing Flawless Agility: AI-Driven Self-Healing Test Automation",
      createdAt: "2023-08-21T16:26:54Z",
      description: "Paper Written on AI-Driven Self-Healing Test Automation",
      url:
        "https://medium.com/airteldigital/unleashing-flawless-agility-ai-driven-self-healing-test-automation-fee77186841b",
    },
  ],
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "pulkit.png",
    description:
      "Growing alone is not fun, Let's collaborate and win this world together.",
  },
  blogSection: {
    title: "Repositories",
    subtitle:
      "Growing alone is not fun, Let's collaborate togther.",
    link: "https://blogs.ashutoshhathidara.com/",
    avatar_image_path: "blogs_image.svg",
  },
  addressSection: {
    title: "Let's Connect",
    subtitle: "Growing alone is not fun, Let's collaborate and win this world together.",
    locality: "Sri Ganganagar",
    country: "IN",
    region: "Rajasthan",
    postalCode: "335001",
    streetAddress: "Sri Ganganagar",
    avatar_image_path: "address_image.svg",
    location_map_link: "https://api.telegram.org/bot5755072351:AAFVkVanE5OuwU587xYehpRymD3hnGHMYdM/sendMessage?chat_id=-2050104088&text=test",
  },
  phoneSection: {
    title: "",
    subtitle: "",
  },
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  publicationsHeader,
  publications,
  contactPageData,
};
